import _ from "lodash";
import { createEncryptedAsyncThunk } from "../../Utility/APIUtils";
import {
  AddBankDetails,
  ChangePassword,
  CheckPinPackageIsValid,
  CheckUserPancardDetails,
  CreateUser,
  GetBankDetailsById,
  GetBankList,
  GetMasterDataList,
  GetUserDetails,
  GetUserDetailsByRole,
  GetUserLotteryDetails,
  UpdateBankDetails,
  UpdateUserDetails,
} from "../apiPath";
import { createSlice } from "@reduxjs/toolkit";

export const changePasswordAction = createEncryptedAsyncThunk(
  "userMgtSlice/changePasswordAction",
  ChangePassword,
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      oldPassword: params.oldPassword,
      password: params.newPassword,
      ipAddress: params.ip,
    }),
  }
);

export const getUserSelfProfileDetails = createEncryptedAsyncThunk(
  "userMgtSlice/getUserProfileDetails",
  GetUserDetails,
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      userDetailsID: Number(params.userID) || 0,
      documentRequired: params.documentRequired || 0,
    }),
  }
);

export const getUserProfileDetails = createEncryptedAsyncThunk(
  "userMgtSlice/getUserProfileDetails",
  GetUserDetails,
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      userDetailsID: Number(params.userID) || 0,
      documentRequired: params.documentRequired || 0,
    }),
  }
);

export const getAllUsersByRole = createEncryptedAsyncThunk(
  "userMgtSlice/getAllUsers",
  GetUserDetailsByRole, // Function that takes params and returns the URL
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      role: params.roleId || 0,
      documentRequired: params.docs ? params.docs : 0,
      status: params.status || 3,
      senior_id: params.seniorId || 0,
      apiUser: params.apiUser || 3,
    }),
  }
);

export const checkUserPancardDetailsAction = createEncryptedAsyncThunk(
  "userMgtSlice/checkUserPancardDetailsAction",
  CheckUserPancardDetails, // Function that takes params and returns the URL
  {
    prepareBody: (params) => ({
      firstname: params.firstName,
      lastname: params.lastName,
      pancardDetails: params.pancard,
      authPwd: process.env.REACT_APP_API_AUTH_PASSWORD,
    }),
  }
);

export const checkPinPackageIsValidAction = createEncryptedAsyncThunk(
  "userMgtSlice/checkPinPackageIsValidAction",
  CheckPinPackageIsValid, // Function that takes params and returns the URL
  {
    prepareBody: (params) => ({
      pinpackage: params.pinpackage,
      package_Id: params.package_Id
    }),
  }
);

export const createNewUser = createEncryptedAsyncThunk(
  "userMgtSlice/createNewUser",
  CreateUser,
  {
    prepareBody: (params) => {
      const list = {
        userID: params.userGuid || "",
        pinpackage: params.pinpackage || "",
        nameTitle: params.nameTitle || "",
        username: params.username || "",
        systemSupportUsername: params.systemSupportUsername || "",
        password: params.password || "",
        tpin: params.tpin || "",
        pancard: params.pancard || "",
        addharcardNumber: params.addharcardNumber || "",
        emailAddress: params.emailAddress || "",
        firstName: params.firstName || "",
        middleName: params.middleName || "",
        lastName: params.lastName || "",
        primaryPhone: params.primaryPhone || "",
        primaryPhoneType: params.primaryPhoneType || 0,
        secondaryPhone: params.secondaryPhone || "",
        secondaryPhoneType: params.secondaryPhoneType || 0,
        role: params.role || 0,
        senior_ID: params.senior_ID || 0,
        package_Id: params.package_Id || 0,
        position_ID: params.position_ID || 0,
        position: params.position || "",
        business_Name: params.business_Name || "",
        business_Add: params.business_Add || "",
        business_Contact_No: params.business_Contact_No || "",
        business_Type: params.business_Type || "",
        state_ID: params.state_ID || 0,
        city_ID: params.city_ID || 0,
        pincode: params.pincode || "",
        area: params.area || "",
        landMark: params.landMark || "",
        address: params.address || "",
        created_By: params.created_By || 0,
        plan_id: params.plan_id || 0,
        whatsapp_no: params.whatsapp_no || "",
        block_add: params.block_add || "",
        gram_panchayat: params.gram_panchayat || "",
        post_office: params.post_office || "",
        police_thana: params.police_thana || "",
        gram: params.gram || "",
        other: params.other || "",
        dob: params.dob || "",
        custom_Attributes: {
          ip: params.ip || "",
          deviceId: params.deviceId || "",
          deviceType: params.deviceType || "",
          lattitude: params.lattitude || "",
          longitude: params.longitude || "",
        },
      };
      // console.log(list)
      return list;
    },
  }
);

export const updateUserDetails = createEncryptedAsyncThunk(
  "userMgtSlice/updateUserDetails",
  UpdateUserDetails,
  {
    prepareBody: (params) => {
      const list = {
        userID: params.userGuid,
        updateUserID: _.toString(params.userID),
        systemSupportUsername: params.systemSupportUsername || "",
        otp: "",
        emailAddress: params.emailAddress || "",
        mobile: params.primaryPhone || "",
        nameTitle: params.nameTitle || "",
        firstname: params.firstName || "",
        middleName: params.middleName || "",
        lastname: params.lastName || "",
        pancard: params.pancard || "",
        nominee: params.nominee || "",
        nominee_type: params.nominee_type || "",
        addharcardNumber: params.addharcardNumber || "",
        plan_Id: params.planId || 0,
        packageId: params.packageId || 0,
        primaryPhoneType: params.primaryPhoneType || "",
        status: params.status || 0,
        pincode: params.pincode || "",
        whatsapp_no: params.whatsapp_no || "",
        block_add: params.block_add || "",
        gram_panchayat: params.gram_panchayat || "",
        post_office: params.post_office || "",
        police_thana: params.police_thana || "",
        gram: params.gram || "",
        other: params.other || "",
        updatedBy: params.updatedBy || 0,
        secondryno: params.secondaryPhone || "",
        landmark: params.landMark || "",
        business_Name: params.business_Name || "",
        business_Contact_No: params.business_Contact_No || "",
        business_Add: params.business_Add || "",
        address: params.address || "",
        dob: params.dob || "",
        city_ID: params.city_ID || 0,
        state_ID: params.state_ID || 0,
      };
      return list;
    },
  }
);

export const getMasterDataListFromAction = createEncryptedAsyncThunk(
  "userMgtSlice/getMasterDataListFromAction",
  GetMasterDataList,
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      role_Id: Array.isArray(params.roleId)
        ? params.roleId
        : [Number(params.roleId) || 0],
      masterDatakey: params.masterDatakey || "",
    }),
  }
);

export const GetBankListAction = createEncryptedAsyncThunk(
  "userMgtSlice/GetBankListAction",
  GetBankList,
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      bankId: params.bankId || 0,
    }),
  }
);

export const getBankDetailsByIdAction = createEncryptedAsyncThunk(
  "userMgtSlice/getBankDetailsByIdAction",
  GetBankDetailsById,
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      bankuserID: params.bankuserID || 0,
    }),
  }
);

export const addBankDetailsAction = createEncryptedAsyncThunk(
  "userMgtSlice/addBankDetailsAction",
  AddBankDetails,
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      bankId: params.bankId || 0,
      bankUserId: params.bankUserId || 0,
      beneficiaryName: params.beneficiaryName || "",
      branchName: params.branchName || "",
      balanceRequestMode: params.balanceRequestMode || [],
      accountNumber: params.accountNumber || "",
      ifsc: params.ifsc || "",
      isActive: params.isActive || false,
      created_By: params.created_By || 0,
    }),
  }
);

export const UpdateBankDetailsAction = createEncryptedAsyncThunk(
  "userMgtSlice/UpdateBankDetailsAction",
  UpdateBankDetails,
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      id: params.id || 0,
      bankUserId: params.bankUserId || 0,
      bankId: params.bankId || 0,
      beneficiaryName: params.beneficiaryName || "",
      branchName: params.branchName || "",
      balanceRequestMode: params.balanceRequestMode || [],
      accountNumber: params.accountNumber || "",
      ifsc: params.ifsc || "",
      status: _.toString(params.status) || "0",
      updated_By: params.updated_By || 0,
    }),
  }
);

export const getUserLotteryDetailsAction = createEncryptedAsyncThunk(
  "userMgtSlice/getUserLotteryDetailsAction",
  GetUserLotteryDetails, // Function that takes params and returns the URL
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      userDetailsID: Number(params.userID) || 0,
      lotNumber: params.lotNumber || 0,
      status: params.status || 3,
    }),
  }
);

export const resetPasswordUser = createEncryptedAsyncThunk(
  "userMgtSlice/resetPasswordUser",
  `Service/ResetPassword`, // Function that takes params and returns the URL
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      resetUserId: params.userID || '',
      ipaddress: params.location.ip || ''
    }),
  }
);

const userMgtSlice = createSlice({
  name: 'userMgt',
  initialState: {
    user: null
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserSelfProfileDetails.pending, (state) => {
        state.user = null;
      })
      .addCase(getUserSelfProfileDetails.fulfilled, (state, action) => {
        if (action && action.payload && action.payload.data) {
          state.user = _.first(action.payload.data)
        } else {
          state.user = null
        }
      })
      .addCase(getUserSelfProfileDetails.rejected, (state, action) => {
        state.user = null;
      })
  }
})
export default userMgtSlice.reducer;
